import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnnotations = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: "h-6 w-6",
	fill: "none",
	viewBox: "1 1 21 20",
	stroke: "currentColor",
	strokeWidth: 2,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "transparent",
		d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
	})
});
export default SvgAnnotations;
